import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = import.meta.env.VITE_URL || import.meta.env.VITE_URL2;

const getErrorMessage = (error) => {
  if (axios.isAxiosError(error)) {
    return error.response?.data?.error || error.message;
  }
  return error.message;
};

export const checkUserLogin = createAsyncThunk(
  "user/checkUserLogin",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${BASE_URL}/api/checkAuth`, {
        withCredentials: true,
      });

      return res?.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const fetchUserDetailsbyRef = createAsyncThunk(
  "user/fetchUserDetailsbyRef",
  async (data, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${BASE_URL}/api/fetchreferral`, {
        params: {
          referralCode: data,
        },
        withCredentials: true,
      });

      return res?.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const authUserLogin = createAsyncThunk(
  "user/login",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axios.post(`${BASE_URL}/api/auth/login`, payload, {
        withCredentials: true,
      });

      console.log(res, "this is the thunk login data");

      return res?.data;
    } catch (error) {
      console.log(error);
      // IMPORTANT: Pass the exact error message from backend
      if (error.response?.data?.success) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(
        error.response?.data || error.message || "Login failed"
      );
    }
  }
);

export const authUserRegister = createAsyncThunk(
  "user/register",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axios.post(`${BASE_URL}/api/auth/register`, payload);
      console.log(res);

      return res?.data;
    } catch (error) {
      console.log(error);

      if (!error.response?.data?.success) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(
        error.response?.data || error.message || "Registration failed"
      );
    }
  }
);

export const checkUserLogout = createAsyncThunk(
  "user/checkUserLogout",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${BASE_URL}/api/auth/logout`, {
        withCredentials: true,
      });

      return res?.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);
